import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';
import { GasSwitchComponent } from './switch/gas-switch.component';
import { GasSwitchControlComponent } from './control/gas-switch-control.component';

const COMPONENTS = [
  GasSwitchComponent,
  GasSwitchControlComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,
    GasIconsModule,
  ],
})
export class GasSwitchModule { }
